import PayrollDashboard from 'components/Dashboard';

export const Dashboard = () => {
	return (
		<div>
			<PayrollDashboard />
		</div>
	);
};
